import React, { useEffect, useState } from 'react';
import TimeControl from '../time-control/time-control';
import useDate from '../../hooks/useDate';
import OutsideClick from '../outside-click/outside-click';
import { useFormikContext } from 'formik';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';

const TimeField = (props) => {
    const { translate } = useLocale();
    const [visible, setVisible] = useState(false);
    const { values, setFieldValue } = useFormikContext();

    const objectValues = values as object;
    const [date, setDate] = useState<Date | null>(objectValues[props.valueName])

    const {
        // date,
        incHours,
        incMins,
        decHours,
        decMins,
        now,
        onHoursChange,
        onMinutesChange
    } = useDate(objectValues[props.valueName], date, setDate);
    const localeTimeOpts: any = { hour: '2-digit', minute: '2-digit' };

    useEffect(() => {
        if (date) {
            setFieldValue(props.valueName, date);
        }
    }, [date]);

    useEffect(() => {
        setDate(objectValues[props.valueName]);
    }, [objectValues])



    return (
        <div className="flex flex-col w-full" >
            <div
                className={`flex flex-row ${props.width ?? 'w-full'} justify-between items-center`}
                onClick={() => setVisible(!visible)}>
                {date
                    ? <span className="p-1 pl-1 text-gray-800 text-sm bg-gray-input w-full">{date.toLocaleString([], { ...localeTimeOpts })}</span>
                    : <span className="p-1 pl-2 text-gray-500 text-sm bg-gray-input w-full">{props.placeholder || translate.byKey(TranslationKeys.selectTime)}</span>
                }
            </div>
            <div className="relative">
                {visible
                    ? (
                        <OutsideClick onClick={() => setVisible(!visible)}>
                            <div className={`flex flex-row shadow-2xl border ${props.width ?? 'w-full'}  justify-between items-center text-xs mt-1 p-1 absolute bg-white z-50`} >
                                <TimeControl
                                    date={((date) => {
                                        if (date) {
                                            return date;
                                        }
                                        else {
                                            const newDate = new Date(Date.now());
                                            setDate(newDate);
                                            return newDate;
                                        }
                                    })(date)}
                                    decMins={decMins}
                                    incMins={incMins}
                                    decHours={decHours}
                                    incHours={incHours}
                                    now={now}
                                    onHoursChange={onHoursChange}
                                    onMinutesChange={onMinutesChange}
                                />
                            </div>
                        </OutsideClick>
                    )
                    : null
                }
            </div>
        </div>
    );
}

export default TimeField;
